import { SkeletonList } from '@aibees/shared/components';
import { classnames, repeat } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { JobTitleListLoadingProps as Props } from './types';

export const JobTitleListLoading = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('JobTitleListLoading', className)}
      sx={SX.root}
    >
      <SkeletonList
        count={[{ variant: 'rounded', height: 32 }]}
        sx={{ flexDirection: 'column', gap: 1.5 }}
      />

      <SkeletonList
        count={repeat({ variant: 'rounded', width: 126, height: 32 }, 2)}
        sx={{ flexDirection: 'row', gap: 1.5 }}
      />

      <SkeletonList
        count={repeat({ variant: 'rounded', width: 186, height: 32 }, 2)}
        sx={{ flexDirection: 'row', gap: 1.5 }}
      />
      <SkeletonList
        count={[{ variant: 'rounded', width: 297, height: 32 }]}
        sx={{ flexDirection: 'row', gap: 1.5 }}
      />
      <SkeletonList
        count={[
          { variant: 'rounded', width: 67, height: 32 },
          { variant: 'rounded', width: 79, height: 32 },
          { variant: 'rounded', width: 67, height: 32 },
        ]}
        sx={{ flexDirection: 'row', gap: 1.5 }}
      />
      <SkeletonList
        count={[{ variant: 'rounded', width: 137, height: 32 }]}
        sx={{ flexDirection: 'row', gap: 1.5 }}
      />
    </Styled.Wrapper>
  );
});

JobTitleListLoading.displayName = 'JobTitleListLoading';
